import dayjs from 'dayjs';
import jsonwebtoken from 'jsonwebtoken';

export function getAge(dob?: string): null | number {
  if (!dob) {
    return null;
  }
  return dayjs().diff(dob, 'y');
}

export interface JsonWebToken {
  exp: number;
}

export function decodeJWT(jwt: string): JsonWebToken | null {
  const result = jsonwebtoken.decode(jwt, { complete: true });
  if (result?.payload) {
    return result.payload;
  }
  return null;
}
